export default "__VITE_ASSET__B8yP3MzE__"